export default __webpack_public_path__ + "assets/Reporter5.png";